import React from "react";
import MyAccountTab from "./MyAccountTab";
import CashierTab from "./CashierTab";
import CouponTab from "./CouponTab";
import RefundTab from "./RefundTab";
import BonusTab from "./BonusTab";
import ReferFriendTab from "./ReferFriendTab";
import AutoPromoTab from "./AutoPromoTab";
import AutoWithdrawTab from "./AutoWithdrawTab";
import WheelSpinTab from "./WheelSpinTab";
import ActivityTab from "./ActivityTab";

export const menuTabs = [
  {
    id: "wheelspin",
    label: "กงล้อพารวย",
    icon: "glyphs-poly:target",
    component: WheelSpinTab,
    group: "menu",
  },
  {
    id: "autoPromo",
    label: "ตั้งค่าโปรโมชั่น",
    icon: "fluent-color:gift-24",
    component: AutoPromoTab,
    group: "menu",
  },

  {
    id: "deposit",
    label: "ฝากเงิน",
    icon: "solar:add-circle-bold-duotone",
    component: () => <CashierTab initialTab="deposit" hideTabs />,
    group: "deposit",
  },
  {
    id: "withdraw",
    label: "ถอนเงิน",
    icon: "solar:minus-circle-bold-duotone",
    component: () => <CashierTab initialTab="withdraw" hideTabs />,
    group: "deposit",
  },
  {
    id: "autowithdraw",
    label: "ตั้งถอนอัตโนมัติ",
    icon: "solar:alarm-bold-duotone",
    component: AutoWithdrawTab,
    group: "deposit",
  },
  {
    id: "cashtocredit",
    label: "แลกกระเป๋าเงินสด",
    icon: "fluent-color:arrow-clockwise-dashes-32",
    component: () => <CashierTab initialTab="cashtocredit" hideTabs />,
    group: "deposit",
  },

  {
    id: "history",
    label: "ประวัติธุรกรรม",
    icon: "fluent-color:text-bullet-list-square-sparkle-32",
    component: () => <CashierTab initialTab="history" hideTabs />,
    group: "deposit",
  },

  {
    id: "coupon",
    label: "เครดิตโค้ด",
    icon: "fluent-color:gift-card-24",
    component: CouponTab,
    group: "menu",
  },
  {
    id: "refund",
    label: "คืนยอดเสีย",
    icon: "fluent-color:arrow-sync-16",
    component: RefundTab,
    group: "cashback",
  },
  {
    id: "bonus",
    label: "แรงค์กิ้ง",
    icon: "fluent-color:ribbon-star-32",
    component: BonusTab,
    group: "menu",
  },
  {
    id: "refer",
    label: "แนะนำเพื่อน",
    icon: "fluent-color:people-community-20",
    component: ReferFriendTab,
    group: "menu",
  },

  {
    id: "activity",
    label: "กิจกรรม",
    icon: "fluent-color:megaphone-loud-16",
    component: ActivityTab,
    group: "menu",
  },
  {
    id: "account",
    label: "บัญชีของฉัน",
    icon: "fluent-color:person-16",
    component: MyAccountTab,
    group: "menu",
  },
  {
    id: "contact",
    label: "ติดต่อเรา",
    icon: "fluent-color:headset-48",
    component: null,
    group: "menu",
  },
];

export const menuSections = [
  {
    id: "cashback",
    label: "คืนยอดเสีย",
    icon: "fluent-color:gift-20",
  },
  {
    id: "deposit",
    label: "ช่องทาง ฝาก-ถอน",
    icon: "fluent-color:vault-20",
  },
  {
    id: "menu",
    label: "เมนู",
    icon: "fluent-color:person-16",
  },
];
